/**
 * WARN: русские label — fallback истории. В модалке EN/RU берётся из
 * `history.fields.Submissions.<field>` (затем `history.fields.common.<field>`).
 * При добавлении или изменении подписи обновляйте обе локали.
 */
export const submissionsFields = {
  product: { label: 'Product', valueType: 'relation' },
  status: { label: 'Статус' },
  country: { label: 'Страна' },
  stage: { label: 'Этап', valueType: 'relation', configPath: 'submissions.stage' },
  critical: { label: 'Критично', valueType: 'bool' },
  favorite: { label: 'Избранное', valueType: 'bool' },
  date_created: { label: 'Дата создания', valueType: 'date' },
  tax_ids: { label: 'Tax № + Tax date' },

  // Этап «Планирование»
  cms: { label: 'CMS', valueType: 'configIdList' },
  submission_type: { label: 'Submission type', valueType: 'configIdList' },
  classification: { label: 'Classification', valueType: 'configIdList' },
  local_docs_to_be_changed: { label: 'Local docs to be changed', valueType: 'configIdList' },
  planned_dispatch_date: { label: 'Planned dispatch date', valueType: 'date' },
  planned_approval_date: { label: 'Planned approval date', valueType: 'date' },
  qe_number: { label: 'QE number' },
  lrf_number: { label: 'LRF number' },
  erv_ro_number_submission_id: { label: 'ERV RO number & Submission ID' },
  prototype_short_ru: { label: 'Short prototype of indications RUS' },
  prototype_short_en: { label: 'Short prototype of indications ENG' },
  prototype_of_indications_ru: { label: 'Full prototype of indications RUS' },
  prototype_of_indications_en: { label: 'Full prototype of indications ENG' },
  clinical_indications_ru: { label: 'Clinical indications RUS' },
  clinical_indications_en: { label: 'Clinical indications ENG' },
  description: { label: 'Description' },
  planned_submission_date: { label: 'Планируемая дата подачи', valueType: 'date' },
  tax_number: { label: 'Tax №' },
  tax_date: { label: 'Tax date', valueType: 'date' },
  pharmacovigilance_support_required: {
    label: 'Требуется поддержка фармаконадзора',
    valueType: 'bool',
  },

  // Этап «Подача»
  submission_date: { label: 'Submission date', valueType: 'date' },
  eec_application_no: { label: 'EEC Application No' },
  moh_tracking_number: { label: 'MoH tracking number' },
  moh_decision_on_expertise_no: { label: 'MoH № of decision on expertise' },
  sent_for_expertise: { label: 'Sent for expertise', valueType: 'date' },
  sent_for_expertise_handout: { label: 'Sent for expertise (hand-out)', valueType: 'date' },
  samples_required: { label: 'Samples required', valueType: 'bool' },

  // Этап «Рассмотрение»
  ha_request_date: { label: 'HA request date', valueType: 'date' },
  moh_ha_request_no: { label: 'MoH № of HA request' },
  planned_response_submission_date: {
    label: 'Planned response submission date',
    valueType: 'date',
  },
  actual_response_submission_date: {
    label: 'Actual response submission date',
    valueType: 'date',
  },
  pharmacovigilance_support_required_review: {
    label: 'Требуется поддержка фармаконадзора (рассмотрение)',
    valueType: 'bool',
  },
  ha_request_doc_num: { label: 'Номер документа' },
  ha_request_doc_date: { label: 'Дата документа', valueType: 'date' },

  // Этап «Лабораторная экспертиза»
  rtms_activity_id: { label: 'RTMS activity' },
  rtms_activity_number: { label: 'RTMS activity number' },
  rtms_activity_status: { label: 'RTMS activity status' },
  rtms_applications: { label: 'Заявки RTMS', valueType: 'rtmsApplications' },
  act_pp_samples_submission_date: { label: 'Samples (submission date)', valueType: 'date' },
  sample_cover_letter: { label: 'Направляющее письмо' },
  act_pp: { label: () => historyPhrase('labels.actPp') },

  // Этап «Одобрение»
  moh_decision_date: { label: 'MoH decision', valueType: 'date' },
  hand_out_date: { label: 'Hand-out', valueType: 'date' },
  ro_in_erv_updated: { label: 'RO in ERV updated', valueType: 'date' },
  ro_in_erv_updated_na: { label: 'RO in ERV updated N/A', valueType: 'bool' },
  artworks_approval_gazelle: { label: 'Artworks approval in GAZELLE', valueType: 'date' },
  artworks_approval_gazelle_na: { label: 'Artworks approval in GAZELLE N/A', valueType: 'bool' },
  latest_implementation_date: { label: 'Latest Implementation Date (LID)', valueType: 'date' },
  latest_implementation_date_na: { label: 'Latest Implementation Date (LID) N/A', valueType: 'bool' },
  gtin_gs1_published: {
    label: 'GTIN is described in GS-1 and published for serialization',
    valueType: 'date',
  },
  gtin_gs1_published_na: {
    label: 'GTIN in GS-1 N/A',
    valueType: 'bool',
  },
}
